/**
 * Key-value display row for info/detail panels.
 *
 * Replaces the repeated pattern:
 *   <div className="flex items-center justify-between">
 *     <span className="text-gray-500">Label</span>
 *     <span>Value</span>
 *   </div>
 */

import type { ReactNode } from "react";

interface InfoRowProps {
  label: string;
  value: ReactNode;
}

export function InfoRow({ label, value }: InfoRowProps) {
  return (
    <div className="flex items-center justify-between">
      <dt className="text-gray-500">{label}</dt>
      <dd className="font-medium text-gray-900">{value}</dd>
    </div>
  );
}
